import {Columns} from 'compob2b-table';
import {translations} from '../../../../../environments/translations.ru';


export const BASKET_TABLE_LOG: Columns[] = [
  {
    key: 'id',
    title: translations.serialNumber,
    placeholder: translations.serialNumber,
    searchEnabled: true,
    formly: false,
    grid: true,
    type: 'input',
    required: true,
  },
  {
    key: 'header',
    title: translations.header,
    placeholder: translations.header,
    searchEnabled: true,
    formly: false,
    grid: true,
    type: 'input',
    required: true,
    width: '80%',
  },
  {
    key: 'createdAt',
    title: translations.createdAtShort,
    placeholder: translations.createdAt,
    searchEnabled: false,
    formly: false,
    grid: true,
    type: 'input',
    required: false,
    className: 'formly-middle',
    cssClass: { includeHeader: false, name: 'font-small' },
    templateOptions: {
      label: translations.createdAt,
      type: 'input',
      readonly: true,
      required: false
    },
  },
  {
    key: 'enabled',
    title: translations.enabled,
    placeholder: translations.enabled,
    searchEnabled: false,
    formly: true,
    grid: false,
    defaultValue: true,
    type: 'checkbox',
    required: true
  },
  {
    key: 'action',
    title: translations.action,
    placeholder: translations.action,
    searchEnabled: false,
    orderEnabled: false,
    grid: false,
    formly: false,
    type: 'input',
    required: true
  }
];
